<template>
    <g>
        <defs>
            <path id="inMobiIcon-a" d="M15.905.16H.055v13.545h15.85V.16z"/>
            <path id="inMobiIcon-c" d="M0 13.857h99.176V.16H0z"/>
        </defs>
        <g fill-rule="evenodd">
            <path d="M0 14.145h3.524V.525H0"/>
            <g transform="translate(0 .29)">
                <path
                    d="M6.018 13.728h3.577v-8.65c.195-1.29 1.064-1.946 2.607-1.973l3.92-.036c1.165-.012 2.192.93 2.223 2.008l.252 8.61h3.114V4.96C21.593 2 19.543.776 16.62.34h-4.88C8.373.604 6.523 2.29 6.187 5.396c-.338 3.106 0 8.213-.17 8.332zM24.367 13.728h3.577v-8.65c.195-1.29 1.066-1.946 2.607-1.973l3.92-.036c1.166-.012 2.212.93 2.224 2.008l.088 8.4c-.007.147-.022.234-.04.25h3.575v-8.65c.196-1.29 1.065-1.946 2.608-1.973l3.916-.036c1.168-.012 2.215.93 2.227 2.008l.09 8.57 3.275.04V4.96C52.322 2.148 50.47.906 47.784.414c-.34-.062-.53-.074-.874-.074h-4.447c-1.646.13-2.927.597-3.848 1.404C37.72.99 36.458.562 34.97.34h-4.88c-3.368.264-5.218 1.95-5.554 5.056-.338 3.106 0 8.213-.17 8.332"
                />
                <g transform="translate(77.327)">
                    <path
                        d="M3.3 8.145h7.962c.786 0 1.43.603 1.43 1.343 0 .737-.644 1.343-1.43 1.343H3.3V8.146zm0-5.26h7.53c.744 0 1.353.57 1.353 1.27 0 .698-.61 1.27-1.354 1.27H3.3v-2.54zM.055.156v13.548H12.28c3.6-.044 4.887-4.78 2.163-7.295 2.52-2.916-.088-6.646-3.407-6.215L.056.157z"
                        mask="url(#nMobiIcon-a)"/>
                </g>
                <mask id="inMobiIcon-d" fill="#fff">
                    <use xlink:href="#inMobiIcon-c"/>
                </mask>
                <path mask="url(#inMobiIcon-d)"
                      d="M95.65 13.857h3.524V.235H95.65M54.616 4.837c.767-1.01 2.01-1.674 3.734-1.99 1.076-.195 1.976-.17 3.06-.166l7.835.014c.855 0 1.647.11 2.285.854-.402-2.12-1.71-3.373-3.864-3.373H61.01c-.987 0-1.732-.018-2.7.255-2.222.628-3.268 2.246-3.694 4.407"/>
                <path
                    d="M58.346 3.242c-.37.358-.752.892-.752 1.663v4.387c.286 1.153 1.033 1.906 2.56 1.982h9.31c.492-.006.97-.087 1.416-.32-.88 1.136-2.21 1.83-3.76 2.307-1.555.482-2.26.535-3.85.535h-3.402c-3.095-.39-4.74-1.87-5.21-4.235V5.696c0-1.1 2.605-2.405 3.688-2.454"
                    mask="url(#inMobiIcon-d)"/>
                <path
                    d="M66.746 13.755H69.7c2.586 0 5.29-2.528 5.29-4.434V4.637c0-2.293-2.873-4.4-5.52-4.45 1.86.9 2.56 2.437 2.56 4.294v4.733c0 2.146-2.78 3.88-5.284 4.542"
                    mask="url(#inMobiIcon-d)"/>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'InMobiIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 100 15');
    }
};
</script>
